import controller from './autocomplete.controller';
import templateBase from './templates/autocomplete-base.view.html';

function AutocompleteDirective(SessionService) {

    //let response = SessionService.get('components');
    let htmlTemplate = templateBase;

    /*if(response.AUTOCOMPLETE.component == 'template_t1'){
        htmlTemplate = template_t1;
    }*/

    return {
        restrict: 'E',
        template: htmlTemplate,
        replace: false,
        bindToController: true,
        scope: {
            myValue: "=myAttribute",
            isReq: "=",
            isDis: "=",
            tooltipP: "=",
            typeaheadSelect: '&',
            onBlurInput: '&',
            idCity: "@",
            isEditable: "=",
            appendBody: "=",
            placeholder: "@",
            param: "@"
        },
        controller,
        controllerAs: 'ctrl'
    };
}

AutocompleteDirective.$inject = ['SessionService'];

// let AutocompleteComponent = {
//   template,
//   controller,
//   scopes : {
//     myValue: "<",
//     isReq: "<",
//     isDis : "<",
//     tooltipP :  "<",
//     idCity : "<",
//     isEditable: "<",
//     placeholder : "<",
//     param : "<"
//   }
// };

// export default AutocompleteComponent;
export default AutocompleteDirective;



// WEBPACK FOOTER //
// ./www/components/shared/components/autocomplete/autocomplete.directive.js